import { router } from "expo-router";
import { ScrollView } from "react-native";
import { CounterForm } from "~/features/counters/CounterForm";
import { ModalHeader } from "~/components/ui/ModalHeader";
import { Screen } from "~/components/ui/Screen";
import { useCounters } from "~/state/counters";

export default function NewCounterScreen() {
  const { addCounter } = useCounters();

  return (
    <Screen>
      <ModalHeader title="New counter" onClose={() => router.back()} />
      <ScrollView keyboardShouldPersistTaps="handled">
        <CounterForm
          submitLabel="Add"
          onSubmit={async (value) => {
            await addCounter(value);
            router.back();
          }}
        />
      </ScrollView>
    </Screen>
  );
}
